import React from 'react';
import { observer } from 'mobx-react';

import { Alert } from '@infoods/lifebase-ui';

import classes from './GeneralSubscriptionInformation.module.scss';
import { SubscriptionTypeChip } from '../../../../../components/SubscriptionTypeChip/SubscriptionTypeChip';
import { DiscountChip } from '../../../../../components/DiscountChip/DiscountChip';
import { currentSubscriptionPlanStore } from '../../../../../stores/currentSubscriptionPlanStore';
import { DISCOUNT_TYPE } from '../../../../../constants/discountType';
import { getIsNonPaidSubscriptionFromFlags } from '../../../../../utils/getIsNonPaidSubscription/getIsNonPaidSubscription';

const GeneralSubscriptionInformation = observer(() => {
  const { currentSubscriptionPlan, subscriptionTypeFlags } = currentSubscriptionPlanStore;
  const { subscription, promocode, explorePlan } = currentSubscriptionPlan || {};

  if (explorePlan) {
    return (
      <Alert severity="warning" size="small">
        <span className={classes.subscriptionNotPaid}>{explorePlan.name} </span>
        is not paid by the user
      </Alert>
    );
  }

  if (!subscription) {
    return <h5 className={classes.title}>No Subscription</h5>;
  }

  const isNotPaidSubscription = getIsNonPaidSubscriptionFromFlags(subscriptionTypeFlags);

  return (
    <div className="private-info">
      <h5 className={classes.title}>
        {subscription.name}
        <DiscountChip
          show={subscription.discountType === DISCOUNT_TYPE.PROMOCODE}
          discountPercent={promocode?.discountPercent}
        />
      </h5>
      {!isNotPaidSubscription && (
        <SubscriptionTypeChip subscriptionType={subscription.subscriptionType} />
      )}
    </div>
  );
});

export { GeneralSubscriptionInformation };
